'use strict';

import {gsap} from 'gsap';
import 'mmenu-js';

const menuTrigger = document.getElementById('menu-trigger')
const homeMenuTrigger = document.getElementById('home-menu-trigger')
const menu = document.querySelector('.tc-website-megamenu')
const menuColumns = menu.querySelectorAll('.mega-menu-navigation > ul > li')
const menuClose = menu.querySelector('.menu-close')
const body = document.body

const buildDesktopMenu = () => {
    menuTrigger.removeAttribute('href')
    menuTrigger.addEventListener('click', openDesktopMenu)
    menuClose.addEventListener('click', closeDesktopMenu)

    if (homeMenuTrigger) {
        homeMenuTrigger.removeAttribute('href')
        homeMenuTrigger.addEventListener('click', openDesktopMenu)
    }
}

const openDesktopMenu = () => {
    document.body.classList.add('menu-open');

    gsap.set(menu, { visibility: "visible" })
    gsap.fromTo(menu,
        { opacity: 0 },
        { opacity: 1, duration: 0.5, ease: "power3.out" }
    )
    gsap.set(menuColumns, { x: "-100%", opacity: 0, scale: 0.8 })
    gsap.to(menuColumns, {
        x: "0%",
        opacity: 1,
        scale: 1,
        duration: 0.4,
        ease: "power2.out",
        stagger: 0.05
    })
}

const closeDesktopMenu = () => {
    document.body.classList.remove('menu-open');
    gsap.to(menu, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => {
            gsap.set(menu, { visibility: "hidden" })
        }
    })
}

const buildMobileMenu = () => {
    const $body = $('body');
    const $mmenu = new Mmenu(document.querySelector('#mmenu'), {
        slidingSubmenus: false,
        offCanvas: {
            position: "right-front"
        },
        theme: 'light',
        navbar: {
            add: false
        },
        navbars: [
            {
                position: 'top',
                content: [
                    $('.mmenu-navbars > .navbar-top').html()
                ]
            },
            {
                position: 'bottom',
                content: [
                    $('.mmenu-navbars > .navbar-bottom').html()
                ]
            }
        ]
    }, {
        classNames: {
            selected: "current"
        },
        offCanvas: {
            clone: true,
            menu: {
                insertSelector: 'body'
            },
            page: {
                nodetype: '.global-container'
            }
        }
    });

    var mMenu = $mmenu.API;
    $('.menu-trigger').on('click', function () {
        if ($('#mmenu').hasClass('mm-menu_opened')) {
            $body.removeClass('mobile-menu-opened');
            mMenu.close();
        } else {
            $body.addClass('mobile-menu-opened');
            mMenu.open();
        }
        return false;
    });

    $('.mmenu-close').on('click', function () {
        $body.removeClass('mobile-menu-opened');
        mMenu.close();
    });

    $('.mmenu').find('.mm-panel').each(function () {
        if ($(this).attr('id') !== 'mm-1') {
            var nbItems = $(this).children().children().length;
            $(this).css('max-height', (nbItems * 60) + 80 + 'px');
        }
    });
}

export default {buildDesktopMenu, buildMobileMenu}
